import { Paper, ActionIcon, Table } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

export default function UserLogins({ user }) {
  return (
    <Paper>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Provider</Table.Th>
            <Table.Th>Last Used</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {user.logins?.map((login) => (
            <Table.Tr key={login.provider} c="dimmed">
              <Table.Td>{login.provider}</Table.Td>
              <Table.Td>{login.lastUsed}</Table.Td>
              <Table.Td ta="right">
                <ActionIcon variant="subtle" color="red">
                  <IconTrash size={16} />
                </ActionIcon>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}
